import React from 'react'
import { View, StyleSheet } from 'react-native'
import { Toggle, Text } from '@ui-kitten/components'
import { Controller } from 'react-hook-form'

export default function FormToggle({
  control,
  name,
  children,
  disabled = false,
  style,
  textStyle,
  checked,
  onChange: customOnChange,
  label,
  labelAccessory,
  testID,
}) {

  return (
    <>
      {label && (
        <View style={styles.labelContainer}>
          <Text category='label' style={styles.label}>
            {label}
          </Text>
          {labelAccessory && labelAccessory()}
        </View>
      )}
      <Controller
        name={name}
        control={control}
        render={({field: { onChange, value }}) => (
          <Toggle
            checked={checked !== undefined ? checked : value}
            onChange={(newValue) => {
              if (customOnChange) {
                customOnChange(newValue)
              } else {
                onChange(newValue)
              }
            }}
            style={[styles.toggleField, style]}
            disabled={disabled}
            testID={testID}
          >
            {evaProps => <Text {...evaProps} style={[evaProps.style, {flexShrink: 1}, textStyle]}>
              {children}
            </Text>}
          </Toggle>
        )}
      />
    </>
  )
}

const styles = StyleSheet.create({
  toggleField: {
    alignSelf: 'flex-start',
  },
  labelContainer: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  label: {
    marginTop: 15,
    marginBottom: 5,
  },
}) 